import React from "react";
import { Link } from "react-router-dom"; // only if you're using React Router

const FooterNote = () => {
    return (
        <footer className="w-full px-4 py-6">
            <div className="flex justify-between items-center text-xs text-gray-500 w-full">
                <p>© 2026 Thoughts by <a href="https://arake.app" target="_blank" rel="noopener noreferrer" className="underline hover:text-orange-400 transition-colors">arake.app</a>. All rights reserved.</p>

                {/* Use <a> if you're not using React Router */}
                <a
                    href="/privacy"
                    className="underline hover:text-gray-700 transition"
                >
                    Privacy & Terms
                </a>

                {/* Or, if using React Router: */}
                {/* 
        <Link
          to="/privacy"
          className="underline hover:text-gray-700 transition"
        >
          Privacy & Terms
        </Link> 
        */}
            </div>
        </footer>
    );
};

export default FooterNote;
